import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AttributionExportItem, CartouchesService } from '../../../services/cartouches.service';

@Component({
  selector: 'app-cartouches-attribuees-sans-sequencage-taches',
  imports: [CommonModule, RouterLink],
  templateUrl: './cartouches-attribuees-sans-sequencage-taches.component.html',
  styleUrl: './cartouches-attribuees-sans-sequencage-taches.component.scss'
})
export class CartouchesAttribueesSansSequencageTachesComponent implements OnInit {
  protected loading = false;
  protected error = '';
  protected items: AttributionExportItem[] = [];

  constructor(
    private readonly cartouchesService: CartouchesService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.load();
  }

  protected refresh(): void {
    this.load();
  }

  protected formatDate(dateString: string | null | undefined): string {
    if (!dateString) {
      return '';
    }
    try {
      return new Date(dateString).toLocaleDateString('fr-FR');
    } catch {
      return dateString;
    }
  }

  private load(): void {
    this.loading = true;
    this.error = '';
    this.cdr.markForCheck();

    this.cartouchesService.exportAttributionsData().subscribe({
      next: (items: AttributionExportItem[]) => {
        this.items = items.filter((item) => item.sequencage_commande !== true);
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: (err: HttpErrorResponse) => {
        this.items = [];
        this.error = this.getErrorMessage(err);
        this.loading = false;
        this.cdr.markForCheck();
      }
    });
  }

  private getErrorMessage(err: HttpErrorResponse): string {
    if (typeof err.error === 'string' && err.error.trim()) {
      return err.error;
    }
    if (err.error?.detail) {
      return String(err.error.detail);
    }
    if (err.error?.message) {
      return String(err.error.message);
    }
    return err.statusText || 'Erreur inconnue';
  }
}